
import React, { useMemo, useRef } from 'react';
import { Card, ListView, Flex } from 'antd-mobile';
import { Error, Loading } from '.';

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
});

function AgentUserList(props) {

  const { loading, errorMessage, companyList } = props;
  const listRef = useRef();

  const dataSourceList = useMemo(() => dataSource.cloneWithRows(companyList), [companyList])

  const row = (item) => {
    return <Card key={item.Id} style={{ marginBottom: '10px' }}>
      <Card.Header
        title={item.Email || '邮箱不存在'}
      />
      <Card.Body style={{ paddingBottom: '10px' }}>
        <Flex className='flex'>
          <Flex.Item className='description-title'>ID</Flex.Item>
          <Flex.Item className='description-content'>{item.Id || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>名称</Flex.Item>
          <Flex.Item className='description-content'>{item.DisplayName || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>手机号</Flex.Item>
          <Flex.Item className='description-content'>{item.Phone || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>注册地</Flex.Item>
          <Flex.Item className='description-content'>{item.RegisterCountry || '-'}</Flex.Item>
        </Flex>
      </Card.Body>
    </Card>
  }

  return (
    <Loading loading={loading} >
      {errorMessage ?
        <Error message={errorMessage} /> : <>
          <ListView
            ref={listRef}
            initialListSize={5}
            dataSource={dataSourceList}
            renderRow={row}
            style={{
              height: '100vh',
              overflowY: 'auto'
            }}
            pageSize={5}
            scrollRenderAheadDistance={200}
          />
        </>
      }
    </Loading>
  )
}

export default AgentUserList